/* eslint-disable no-param-reassign */
import _ from 'underscore';

function createDispatcher(self, callback) {
    const dispatcher = {
        getPanelInfo(name) {
            let result = self.state.panels[name];
            if (!result) {
                result = {};
                self.state.panels[name] = result;
            }
            return result;
        },
        markAs(name, status) {
            if (dispatcher.getPanelInfo(name).status === status) {
                return;
            }
            dispatcher.getPanelInfo(name).status = status;
            callback(name);
        },
        togglePanel(name, close) {
            const panelInfo = dispatcher.getPanelInfo(name);
            panelInfo.open = !panelInfo.open && !close;
            callback(name);
        },
        openPanel(name) {
            const panelInfo = dispatcher.getPanelInfo(name);
            panelInfo.open = true;
            callback(name);
        },
        markAndClose(name, status) {
            dispatcher.markAs(name, status);
            dispatcher.togglePanel(name, true);
        },
        setValidationResults(name, validationResults) {
            dispatcher.getPanelInfo(name).validationResults = validationResults;
            callback(name);
        },
        markAsComplete(name) {
            dispatcher.markAs(name, 'complete');
        },
        markAsIncomplete(name) {
            dispatcher.markAs(name, 'incomplete');
        },
        markAsCompletedAndClose(name) {
            dispatcher.markAndClose(name, 'complete');
        },
        markAsIncompleteAndClose(name) {
            dispatcher.markAndClose(name, 'incomplete');
        },
        toggleHelpNote(noteId, positionParent, toVisibleState) {
            if (toVisibleState === null) {
                self.state.helpNotes[noteId].visible = !self.state.helpNotes[noteId].visible;
            } else {
                self.state.helpNotes[noteId].visible = _.isBoolean(toVisibleState)
                    ? toVisibleState
                    : !self.state.helpNotes[noteId].visible;
            }
            if (positionParent !== null) self.state.helpNotes[noteId].positionParent = positionParent;
            self.setState(self.state);
        },
        lockPanel(name) {
            const panelInfo = dispatcher.getPanelInfo(name);
            panelInfo.locked = true;
            callback(name);
        },
        unlockPanel(name) {
            const panelInfo = dispatcher.getPanelInfo(name);
            panelInfo.locked = false;
            callback(name);
        },
    };

    return dispatcher;
}

export default {
    createDispatcher,
};
